// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xRBF","rootMobile":"styles_rootMobile__uJOVU"};